<template>
  <div id="header" class="md-layout-row">
    <el-popover
      placement="bottom"
      trigger="manual"
      class="remove-popup"
      v-model="visible"
    >
      <div>
        <div class="relative">
          <div
            class="card-tutorial members center fc-000000"
            :class="{
              members: stepTutorial === 1,
              questions: stepTutorial === 2,
              rewards: stepTutorial === 3,
              insights: stepTutorial === 4,
              settings: stepTutorial === 5,
            }"
          >
            <div class="relative">
              <div class="arrow-tutorial"></div>
            </div>
            <div v-if="stepTutorial === 1">
              <div class="title-tutorial mb-24">{{ $t('page.members') }}</div>
              <div class="content-tutorial">
                Add members to your account, organize your teams, and
              </div>
              <div class="content-tutorial">view your manager activity.</div>
              <div style="color: #fff">{{ tutoriat }}</div>
              <img
                src="@/assets/images/registor/illus_tutorial_1@2x.png"
                style="height: 220px; margin-top: 42px"
              />
            </div>
            <div v-if="stepTutorial === 2">
              <div class="title-tutorial mb-24">{{ $t('page.questions') }}</div>
              <div class="content-tutorial">
                Enable or disable our standard questions, view results, and
              </div>
              <div class="content-tutorial">
                add your own custom questions here
              </div>
              <div style="color: #fff">{{ tutoriat }}</div>
              <img
                src="@/assets/images/registor/illus_tutorial_2@2x.png"
                style="height: 200px; margin-top: 62px"
              />
            </div>
            <div v-if="stepTutorial === 3">
              <div class="title-tutorial mb-24">{{ $t('page.rewards') }}</div>
              <div class="content-tutorial">
                Enable or disable our standard questions, view results, and
              </div>
              <div class="content-tutorial">
                add your own custom questions here
              </div>
              <div style="color: #fff">{{ tutoriat }}</div>
              <img
                src="@/assets/images/registor/illus_tutorial_3@2x.png"
                style="height: 210px; margin-top: 52px"
              />
            </div>
            <div v-if="stepTutorial === 4">
              <div class="title-tutorial mb-24">{{ $t('page.insights') }}</div>
              <div class="content-tutorial">
                Add members to your account, organize your teams, and
              </div>
              <div class="content-tutorial">view your manager activity.</div>
              <div style="color: #fff">{{ tutoriat }}</div>
              <img
                src="@/assets/images/registor/illus_tutorial_4@2x.png"
                style="height: 220px; margin-top: 42px"
              />
            </div>
            <div v-if="stepTutorial === 5">
              <div class="title-tutorial mb-24">{{ $t('page.settings') }}</div>
              <div class="content-tutorial">
                Add members to your account, organize your teams, and
              </div>
              <div class="content-tutorial">view your manager activity.</div>
              <div style="color: #fff">{{ tutoriat }}</div>
              <img
                src="@/assets/images/registor/illus_tutorial_1@2x.png"
                style="height: 220px; margin-top: 42px"
              />
            </div>
            <div class="flex mt-40">
              <div
                @click.prevent="visible = false"
                class="skip-tutorial cursor-pointer"
              >
                SKIP TUTORIAL
              </div>
              <div
                @click.prevent="nextStepTutorial"
                class="next-tutorial cursor-pointer"
              >
                {{ 5 > stepTutorial ? "NEXT" : "DONE" }} ({{ stepTutorial }}/5)
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-popover>
    <div :class="['web-page-container', { 'with-account-rail': hasAccountRail }]">
      <div class="relative mock-navbar"></div>
      <div class="navbar flex-center">
        <div
          class="flex-center cursor-pointer"
          @click.prevent="routerLink('index')"
        >
          <img
            :src="require(`@/assets/images/wv-monthly-insights/Icon.png`)"
            style="width: 32px"
            class="ml-15 animation-logo"
            alt="logo happily"
          />
          <img
            :src="require(`@/assets/images/navbar/happily.ai.png`)"
            style="height: 32px"
            class="ml-2"
            alt="happily"
          />
        </div>
        <div class="hamburger-bar" @click.prevent="showNavbar = !showNavbar">
          <div class="line-menu"></div>
          <div class="line-menu"></div>
          <div class="line-menu"></div>
        </div>
      </div>
      <div class="flex">
        <!-- Account Switcher Rail (for multi-account users) -->
        <account-rail />
        
        <div :class="['menu-container', { 'show-menu': showNavbar }]">
          <!-- <div class="side-menu" :style="`height: ${maxHeightMenu}px;`"> -->
          <div class="side-menu">
            <div class="header-menu" ref="head_menu">
              <div
                class="ws-chip cursor-pointer"
                @click.prevent="routerLink('index')"
                role="button"
                tabindex="0"
                aria-label="Go to home"
              >
                <div class="ws-chip-logo">
                  <img
                    :src="require(`@/assets/images/logo_symbol_only.png`)"
                    alt="Happily"
                    class="animation-logo"
                  />
                </div>
                <div class="ws-chip-meta">
                  <div class="ws-chip-label">{{ $t('global.workspace') }}</div>
                  <div
                    class="ws-chip-name"
                    :class="[ blurMode ?  'blurelement': '' ]"
                  >
                    {{ user.company_name }}
                  </div>
                </div>
              </div>

              <el-dropdown @command="handleCommand" trigger="click">
                <div class="me-pill" role="button" tabindex="0" aria-label="Account menu">
                  <div class="me-pill-av">
                    <img
                      v-if="user.profilepic_crop"
                      v-lazy="user.profilepic_crop"
                      :alt="user.firstname + ' ' + user.lastName"
                      :key="user.pic"
                      class="image-skeleton"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    />
                    <img
                      v-else-if="user.pic"
                      v-lazy="user.pic"
                      :alt="user.firstname + ' ' + user.lastName"
                      class="image-skeleton"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    />
                    <div v-else class="me-pill-av-initials"
                    :class="[ blurMode ?  'blurelement': '' ]">
                      <span class="fw-700">{{
                        $utils("acronymName", {
                          firstName: user.firstname,
                          lastName: user.lastname,
                        })
                      }}</span>
                    </div>
                    <span class="me-pill-presence" aria-hidden="true"></span>
                  </div>
                  <div class="me-pill-text">
                    <div class="me-pill-name"
                    :class="[ blurMode ?  'blurelement': '' ]">
                      {{ user.firstname }} {{ user.lastname }}
                    </div>
                    <div class="me-pill-role">{{ userRoleLabel }}</div>
                  </div>
                  <span class="me-pill-caret" aria-hidden="true">
                    <i class="el-icon-arrow-down"></i>
                  </span>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <div class="dropdown-section">
                    <div class="dropdown-section-title">{{ $t('global.language') }}</div>
                    <el-dropdown
                      placement="left-start"
                      trigger="hover"
                      @command="handleCommand"
                      class="language-submenu"
                    >
                      <el-dropdown-item class="language-submenu-trigger">
                        <div class="language-option">
                          <span class="language-flag">🌐</span>
                          <span class="language-name">{{ getCurrentLanguageName() }}</span>
                          <span class="language-arrow">›</span>
                        </div>
                      </el-dropdown-item>
                      <el-dropdown-menu slot="dropdown" class="language-submenu-content">
                        <el-dropdown-item
                          command="lang-en"
                          :class="{ 'is-active': selectedLanguage === 'en' }"
                        >
                          <div class="language-option">
                            <span class="language-flag">🇺🇸</span>
                            <span class="language-name">English</span>
                            <span v-if="selectedLanguage === 'en'" class="language-check">✓</span>
                          </div>
                        </el-dropdown-item>
                        <el-dropdown-item
                          command="lang-th"
                          :class="{ 'is-active': selectedLanguage === 'th' }"
                        >
                          <div class="language-option">
                            <span class="language-flag">🇹🇭</span>
                            <span class="language-name">ไทย</span>
                            <span v-if="selectedLanguage === 'th'" class="language-check">✓</span>
                          </div>
                        </el-dropdown-item>
                        <el-dropdown-item
                          command="lang-ms"
                          :class="{ 'is-active': selectedLanguage === 'ms' }"
                        >
                          <div class="language-option">
                            <span class="language-flag">🇲🇾</span>
                            <span class="language-name">Bahasa Malaysia</span>
                            <span v-if="selectedLanguage === 'ms'" class="language-check">✓</span>
                          </div>
                        </el-dropdown-item>
                        <el-dropdown-item
                          command="lang-zh-HK"
                          :class="{ 'is-active': selectedLanguage === 'zh-HK' }"
                        >
                          <div class="language-option">
                            <span class="language-flag">🇭🇰</span>
                            <span class="language-name">繁體中文</span>
                            <span v-if="selectedLanguage === 'zh-HK'" class="language-check">✓</span>
                          </div>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                  <el-dropdown-item divided command="logout" class="logout-item">
                    <i class="el-icon-switch-button"></i>
                    <span>{{ $t('global.logout') }}</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="body-menu" ref="body_menu" v-if="permissionLoading">
              <transition name="slide-fade">
                <div v-if="blurMode"
                :class="['demomode-notif', 'flex-between']">
                  <div>{{ $t("demomode.demo_on") }}</div>
                  <el-tooltip effect="dark" placement="bottom">
                    <div class="tooltipStyle" slot="content">
                    {{ $t("demomode.demo_tooltip") }}
                    </div>
                    <div class="flex-center">
                      <img :src="getImgUrl('help_outline-16px')" style="filter:invert(1)"/>
                    </div>
                  </el-tooltip>
                </div>
              </transition>
              
              <!-- Command Search Shortcut Indicator -->
              <div @click="navMode = true" style="margin: 0 0 12px; padding: 0 8px; cursor: pointer;">
                <div class="search-shortcut-container">
                  <div class="search-shortcut-icon">
                    <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.9167 11.6667H12.2583L12.025 11.4417C12.8417 10.4917 13.3333 9.25833 13.3333 7.91667C13.3333 4.925 10.9083 2.5 7.91667 2.5C4.925 2.5 2.5 4.925 2.5 7.91667C2.5 10.9083 4.925 13.3333 7.91667 13.3333C9.25833 13.3333 10.4917 12.8417 11.4417 12.025L11.6667 12.2583V12.9167L15.8333 17.075L17.075 15.8333L12.9167 11.6667ZM7.91667 11.6667C5.84167 11.6667 4.16667 9.99167 4.16667 7.91667C4.16667 5.84167 5.84167 4.16667 7.91667 4.16667C9.99167 4.16667 11.6667 5.84167 11.6667 7.91667C11.6667 9.99167 9.99167 11.6667 7.91667 11.6667Z" fill="#ffffff"/>
                    </svg>
                  </div>
                  <div class="search-shortcut-text">{{ $t('global.Search') }}</div>
                  <div class="search-shortcut-keys">
                    <span class="search-key">{{ isMac ? '⌘' : 'Ctrl' }}</span>
                    <span class="search-key">K</span>
                  </div>
                </div>
              </div>

              <div id="SavedBlurMode">
                <el-dialog top="10vh" width="40%"
                :visible.sync="showSavedBlur" 
                :modal="false"
                :title="$t('demomode.detected_title')">
                  {{ $t("demomode.detected_sub") }}
                </el-dialog>
              </div>

              <div id="NavigationCommandMenu">
                <el-dialog
                :visible.sync="navMode" 
                :modal="false" 
                :show-close="false"
                @closed="clearNav"
                destroy-on-close
                >
                <div class="navsearch">
                  <div class="search-icon">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.9167 11.6667H12.2583L12.025 11.4417C12.8417 10.4917 13.3333 9.25833 13.3333 7.91667C13.3333 4.925 10.9083 2.5 7.91667 2.5C4.925 2.5 2.5 4.925 2.5 7.91667C2.5 10.9083 4.925 13.3333 7.91667 13.3333C9.25833 13.3333 10.4917 12.8417 11.4417 12.025L11.6667 12.2583V12.9167L15.8333 17.075L17.075 15.8333L12.9167 11.6667ZM7.91667 11.6667C5.84167 11.6667 4.16667 9.99167 4.16667 7.91667C4.16667 5.84167 5.84167 4.16667 7.91667 4.16667C9.99167 4.16667 11.6667 5.84167 11.6667 7.91667C11.6667 9.99167 9.99167 11.6667 7.91667 11.6667Z" fill="rgba(0, 0, 0, 0.5)"/>
                    </svg>
                  </div>
                  <el-input id="navsearchBar" ref="navsearchRef" @focus="handleSearchBarRow"
                  v-model="inputSearch" placeholder="Type a command or search..." maxlength="100" resize="horizontal" style="flex: 1"/>
                  <div class="shortcut-indicator">⌘K</div>
                </div>

                <div class="command-container" ref="navdialogbodyRef">
                  <!-- Tables -->
                  <el-table id="recents"
                    ref="recentsRef"
                    v-if="!currentlySearching && hasRecents && !rerenderRecents"
                    :data="commandsRecents"
                    style="width: 100%"
                    :cell-class-name="recentsIndexes"
                    header-cell-class-name="navtable-header"
                    :row-class-name="expandGet"
                    row-key="command_ID"
                    @expand-change="handleExpand"
                    :expand-row-keys="navExpandedRow.current"
                    highlight-current-row
                    @current-change="handleRecentsRow"
                    tabindex="0"
                  >
                  <el-table-column label="Recents" width="100%">
                    <template slot-scope="scope">
                      <div class="command-row">
                        <div class="command-icon">
                          <div @click="handleNavLink(scope.row)">
                            <div class="icon-container">
                              <img :src="require(`@/assets/${scope.row.icon}`)" alt="command icon"/>
                            </div>
                          </div>
                        </div>
                        <div class="command-content">
                          <div class="command-title">{{ scope.row.commandTitle }}</div>
                          <div class="command-description">{{ scope.row.description }}</div>
                        </div>
                        <div class="action-buttons">
                          <button class="delete-button" @click.prevent="deleteRecent(scope.row)" title="Remove from recents">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4Z" fill="rgba(0, 0, 0, 0.5)"/>
                            </svg>
                          </button>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  </el-table>

                  <el-table id="common"
                    ref="commonRef"
                    v-if="!currentlySearching && hasCommon"
                    :data="commandsCommon"
                    style="width: 100%"
                    :cell-class-name="commonIndexes"
                    header-cell-class-name="navtable-header"
                    :row-class-name="expandGet"
                    row-key="command_ID"
                    @expand-change="handleExpand"
                    :expand-row-keys="navExpandedRow.current"
                    highlight-current-row
                    @current-change="handleCommonRow"
                    tabindex="0"
                  >
                  <el-table-column label="Common Actions" width="100%">
                    <template slot-scope="scope">
                      <div class="command-row">
                        <div class="command-icon">
                          <div @click="handleNavLink(scope.row)">
                            <div class="icon-container">
                              <img :src="require(`@/assets/${scope.row.icon}`)" alt="command icon"/>
                            </div>
                          </div>
                        </div>
                        <div class="command-content">
                          <div class="command-title">{{ scope.row.commandTitle }}</div>
                          <div class="command-description">{{ scope.row.description }}</div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  </el-table>

                  <el-table id="searchresults"
                    ref="searchresultsRef"
                    v-if="currentlySearching"
                    :data="commandsResults"
                    style="width: 100%"
                    :cell-class-name="resultsIndexes"
                    header-cell-class-name="navtable-header"
                    :row-class-name="expandGet"
                    row-key="command_ID"
                    @expand-change="handleExpand"
                    :expand-row-keys="navExpandedRow.current"
                    highlight-current-row
                    @current-change="handleResultsRow"
                    tabindex="0"
                  >
                  <el-table-column width="100%">
                    <template #header>
                      <div v-if="jumbledSearching && commandsResults.length != 0">Did you mean:</div>
                      <div v-else-if="commandsResults.length == 0">Sorry, we couldn't find anything that matched!</div>
                      <div v-else>{{ $t('global.search_results') }}</div>
                    </template>
                    <template slot-scope="scope">
                      <div class="command-row">
                        <div class="command-icon">
                          <div @click="handleNavLink(scope.row)">
                            <div class="icon-container">
                              <img :src="require(`@/assets/${scope.row.icon}`)" alt="command icon"/>
                            </div>
                          </div>
                        </div>
                        <div class="command-content">
                          <div id="commandResultsTitle" class="command-title">{{ scope.row.commandTitle }}</div>
                          <div id="commandResultsDesc" class="command-description">{{ scope.row.description }}</div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  </el-table>
                </div>

                <template v-slot:footer>
                  <div class="shortcut-hint">
                    <span>
                        <span class="key">↑</span>
                        <span class="key">↓</span>
                        <span class="shortcut-text">to navigate</span>
                    </span>
                    <span>
                        <span class="key">Enter</span>
                        <span class="shortcut-text">or click</span>
                        <span class="key-icon"><img src="@/assets/images/registor/ic_right_arrow.png" alt="→"/></span>
                        <span class="shortcut-text">to go</span>
                    </span>
                    <span>
                        <span class="key">← Backspace</span>
                        <span class="shortcut-text">to trash</span>
                    </span>
                    <span>
                        <span class="key">Esc</span>
                        <span class="shortcut-text">to dismiss</span>
                    </span>
                </div>
                </template>
                
                </el-dialog>
              </div>

              <div v-if="setupWizardPage" class="router flex-center active">
                <img src="@/assets/images/navbar/noting.png" />
                <div class="label">{{ $t('page.setup_wizard') }}</div>
              </div>
              
              <div
                v-for="group in visibleGroupedSideMenu"
                :key="group.label"
                class="nav-group"
                :class="{ 'is-active': group.label === activeGroupLabel }"
              >
                <div class="nav-group-label">{{ $t(group.i18nKey) }}</div>
                <a
                  v-for="menu in group.items"
                  :key="menu.path"
                  :href="userPermLock(menu.path) ? '' : `https://my.happily.ai/${menu.path}`"
                  :class="{ 'diasable-all': setupWizardPage }"
                >
                  <div
                    :class="`router flex-center ${linkActive(menu.path)}`"
                    @click.prevent="onMenuClick(menu)"
                  >
                    <div class="nav-item-icon">
                      <img
                        :src="linkActive(menu.path) === 'active' ? menu.activeImge || menu.imge : menu.imge"
                        :alt="$t(menu.i18nKey) + ' icon'"
                      />
                    </div>
                    <div class="label">{{ $t(menu.i18nKey) }}</div>
                    <div
                      v-if="menu.notification && menu.notification > 0"
                      class="noti-tag ml-auto flex-mid"
                      :class="{ 'noti-tag-pulse': menu.notification > 0 }"
                    >
                      {{ menu.notification > 99 ? '99+' : menu.notification }}
                    </div>
                    <div v-if="isPlanLocked(menu.path)" class="ml-auto flex-mid plan-badge" aria-label="Pro plan feature">
                      PRO
                    </div>
                    <div v-else-if="userPermLock(menu.path)" class="ml-auto flex-mid lock-icon">
                      <i class="el-icon-lock fc-FFFFFF"></i>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div
              v-if="isFreePlan && !setupWizardPage"
              class="plan-footer-card"
              role="button"
              tabindex="0"
              @click.prevent="goToBillingUpgrade"
              @keydown.enter.prevent="goToBillingUpgrade"
              aria-label="You are on the Free plan. Upgrade to Pro."
            >
              <div class="plan-footer-eyebrow">
                <span class="plan-footer-dot" aria-hidden="true"></span>
                Free plan
              </div>
              <div class="plan-footer-headline">Unlock insights, reports, and more</div>
              <div class="plan-footer-cta">
                Upgrade to Pro
                <span aria-hidden="true">→</span>
              </div>
            </div>
          </div>
        </div>
        <div
          :class="['components-container', { 'with-account-rail': hasAccountRail }]"
          ref="container_of_body"
          style="min-width: 1024px"
        >
          <router-view></router-view>
        </div>
      </div>
    </div>
    <upgrade-modal
      :visible.sync="upgradeModalVisible"
      :feature-name="upgradeModalFeature"
      @close="upgradeModalVisible = false"
    />
  </div>
</template>


<script>
import CryptoJS from 'crypto-js'
import { setLocale } from '@/plugin/vue-lang';
import SettingsPage from '@/components/settings.vue';
import AccountRail from '@/components/main/AccountRail.vue';
import UpgradeModal from '@/components/main/UpgradeModal.vue';
import { PLAN_LOCKED_PATHS } from '@/store/core/authen';
import firebase from "firebase/app";
import "firebase/database";
import _ from 'lodash';
import { nextTick } from 'process';
import { isThisWeek } from 'date-fns';
export default {
  components: {
    'account-rail': AccountRail,
    'upgrade-modal': UpgradeModal,
  },
  created() {
    this.$store.dispatch("authen/getCompanyData", this.user);
    this.$store.dispatch("navCommands/initializeNav", this.user);
    const lastActivity = localStorage.getItem('lastActivity');
    if (lastActivity) {
      this.checkIdleTime();
    }
    this.loadLanguagePreference();
  },
  watch: {
    $route(to, from) {
      this.timeChecked = 1;
      this.backToStart();
      this.setupWizardWatch(to);
      this.checkActiveSession();
    },
    companyData(){
      this.getUrl();
    },

    inputSearch() {
      this.clearExpand();
      this.clearNavTraverse();
      this.navExpandedRow.current = [];
      //if (this.inputSearch.length <= 2) {
        this.removeHighlight();
      //}
      this.$store.dispatch("navCommands/searchCommands", this.inputSearch);
      this.$nextTick(() => {
        this.addHighlight();
        // Auto-select first item if we're searching and there are results
        if (this.currentlySearching && this.commandsResults.length > 0) {
          this.$nextTick(() => {
            if (this.$refs.searchresultsRef) {
              this.$refs.searchresultsRef.setCurrentRow(this.commandsResults[0]);
              // Make sure search input gets focus back
              this.$refs.navsearchRef.focus();
            }
          });
        } else if (this.hasRecents && this.commandsRecents.length > 0 && !this.currentlySearching) {
          this.$nextTick(() => {
            if (this.$refs.recentsRef) {
              this.$refs.recentsRef.setCurrentRow(this.commandsRecents[0]);
              // Make sure search input gets focus back
              this.$refs.navsearchRef.focus();
            }
          });
        } else if (this.hasCommon && this.commandsCommon.length > 0 && !this.currentlySearching) {
          this.$nextTick(() => {
            if (this.$refs.commonRef) {
              this.$refs.commonRef.setCurrentRow(this.commandsCommon[0]);
              // Make sure search input gets focus back
              this.$refs.navsearchRef.focus();
            }
          });
        }
      });
    },
    commandsRecents() {
      this.rerenderRecents = true;
      this.$nextTick(() => this.rerenderRecents = false);
    },
    navMode() {
      this.navListeners();
    },
    inExpandCell() {
      this.navListeners();
    },
    countNewReward(){
      this.sideMenu[4].notification = this.countNewReward.all;
    }
  },
  computed: {
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    permByPath() {
      const out = {};
      this.sideMenu.forEach(m => { out[m.path] = this.userPerm(m.path); });
      return out;
    },
    visibleGroupedSideMenu() {
      const byPath = {};
      this.sideMenu.forEach(m => { byPath[m.path] = m; });
      return this.navGroups
        .map(g => ({
          label: g.label,
          i18nKey: g.i18nKey,
          items: g.paths
            .map(p => byPath[p])
            .filter(m => m && this.permByPath[m.path]),
        }))
        .filter(g => g.items.length);
    },
    activeItemPath() {
      const path = this.$route.path;
      const top = path.split("/")[1];
      if (top) return top;
      if (path === "/" && this.user) {
        return this.user.user_type === "admin" ? "members" : "insights";
      }
      return "";
    },
    activeGroupLabel() {
      const p = this.activeItemPath;
      if (!p) return null;
      const group = this.navGroups.find(g => g.paths.includes(p));
      return group ? group.label : null;
    },
    isFreePlan() {
      // Tier lives on the session user (mirrored from companyData). The
      // signup wizard hardcodes 'free'; legacy accounts default to 'pro'
      // in buildSessionUser, so this is safe for both.
      return !!(this.user && this.user.plan_tier === 'free');
    },
    hasAccountRail() {
      return this.$store.getters["accountSwitcher/shouldShowRail"];
    },
    calcNavHeight() {
      return '400px';
    },
    companyData() {
      return this.$store.getters["authen/companyData"];
    },
    user() {
      return this.$store.getters["authen/user"];
    },
    activeIndex() {
      return this.$store.getters["authen/activeIndex"];
    },
    isMac() {
      return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    },
    tutoriat() {
      let status = false;
      // console.log(this.$router.currentRoute.name)
      // this.$router.currentRoute.name
      // if (this.$route.query.welcome == "true") {
      //   status = true;
      //   this.stepTutorial = 1;
      // } else if (this.$route.query.welcome == "false") {
      //   status = true;
      // }
      // console.log(this.$router.currentRoute);
      // console.log(this.$router, this.$route.query.welcome);
      // if (this.$router.currentRoute.name == "members") {
      //   status = true;
      //   this.stepTutorial = 1;
      // } else if (this.$router.currentRoute.name == "rewards") {
      //   status = true;
      //   this.stepTutorial = 2;
      // } else if (this.$router.currentRoute.name == "insights") {
      //   status = true;
      //   this.stepTutorial = 3;
      // } else if (this.$router.currentRoute.name == "settings") {
      //   status = true;
      //   this.stepTutorial = 4;
      // }
      // setTimeout(() => {
      //   this.visible = status;
      // }, 200);
      return status;
    },
    pagePermission() {
      this.permissionLoading = true;
      return this.$store.getters["authen/pagePermission"];
    },
    commandsMaster() {
      return this.$store.getters["navCommands/getCommands"];
    },
    commandsTags() {
      return this.$store.getters["navCommands/getTags"];
    },
    expandable() {
      return this.$store.getters["navCommands/getExpandable"];
    },
    commandsCommon() {
      return this.$store.getters["navCommands/getCommon"];
    },
    commandsRecents() {
      return this.$store.getters["navCommands/getRecents"];
    },
    commandsResults() {
      return this.$store.getters["navCommands/getSearchResults"];
    },

    inputSearch: {
      get() {
        return this.$store.getters["navCommands/getInputSearch"];
      },
      set(value) {
        this.$store.commit("navCommands/setInputSearch", value);
      },
    },

    currentlySearching() {
      return this.$store.getters["navCommands/getCurrentlySearching"];
    },
    jumbledSearching() {
      return this.$store.getters["navCommands/getJumbledSearching"];
    },
    hasCommon() {
      return this.$store.getters["navCommands/getHasCommon"];
    },
    hasRecents() {
      return this.$store.getters["navCommands/getHasRecents"];
    },
    optionsAll() {
      return this.$store.getters["navCommands/getOptionsAll"];
    },
    timeOptions() {
      return this.$store.getters["navCommands/getTimeOptions"];
    },
    searchHighlights() {
      return this.$store.getters["navCommands/getSearchHighlights"];
    },
    inExpandCell() {
      return this.navExTraverse.inExpandCell;
    },
    countNewReward(){
      return this.$store.getters["reward/countNewReward"];
    },
    isAdvisor() {
      return this.$store.getters["authen/isAdvisor"];
    },
    userRoleLabel() {
      if (this.isAdvisor) return 'Advisor';
      const roleMap = {
        admin: 'Admin',
        hr: 'HR',
        leadership: 'Leadership',
        superleader: 'Super Leader',
        superadmin: 'Super Admin',
        developer: 'Developer',
        ghost: 'Ghost',
        user: 'Member',
      };
      return roleMap[this.user && this.user.user_type] || 'Member';
    },
  },
  data() {
    return {
      upgradeModalVisible: false,
      upgradeModalFeature: '',
      idleTimer: null,
      idleTimeout: 72 * 60 * 60 * 1000, // 72 hours in milliseconds
      activeSessionCheckTimer: null,
      activeSessionCheckInterval: 5 * 60 * 1000, // 5 minutes in milliseconds
      activeSessionCheckInFlight: false,
      insightsActive: false,
      membersActive: false,
      visible: false,
      stepTutorial: 1,
      showNavbar: false,
      maxHeightMenu: 350,
      timeChecked: 1,
      permissionLoading: false,
      setupWizardPage: false,
      urlStausPage: "",
      showSavedBlur: false,
      selectedLanguage: 'en', // Default to English
      navMode: false,
      expandConfig: {
        multiple: true
      },
      navTraverse: {
        refName: 'navsearchRef',
        tableData: '',
        currentRow: '',
        oldCurrentRow: '',
        index: -1,
        expandable: false
      },
      navExTraverse: {
        inExpandCell: false,
        currentCell: '',
        currentElementName: '',
        currentDropped: false,
        elements: [
          ["navExpandSearch", "navExpandTime"],
          "navExpandGo"
        ]
      },
      navExpandedRow: {
        current: [],
        expandSearch: '',
        memberObject: '',
        expandTime: '',
        memberReady: false,
        timeReady: false,
        navCall: false
      },
      focusOptions: {
        preventScroll:true, 
        focusVisible:false
      },
      scrollOptions: {
        behaviour:"smooth",
        block:"nearest",
      },
      rerenderRecents: false,
      sideMenu: [
        // 1 : insights
        {
          label: "Insights",
          i18nKey: "page.insights",
          path: "insights",
          tab: "dashboard",
          imge: require("@/assets/images/navbar/round-insights-24px.png"),
          activeImge: require("@/assets/images/navbar/ic_insights.webp"),
          notification: 0,
        },
        // 2 : members
        {
          label: "Members",
          i18nKey: "page.members",
          path: "members",
          tab: "members",
          imge: require("@/assets/images/navbar/round-members-24px.png"),
          activeImge: require("@/assets/images/navbar/ic_members.webp"),
          notification: 0,
        },
        // 3 : recognition
        {
          label: "Recognition",
          i18nKey: "page.recognition",
          path: "recognition",
          tab: "create",
          imge: require("@/assets/images/navbar/round-gem-24px.png"),
          activeImge: require("@/assets/images/navbar/ic_power-ups.webp"),
          notification: 0,
        },
        // 4 : performance
        {
          label: "Performance",
          i18nKey: "page.performance",
          path: "performance",
          tab: "overview",
          imge: require("@/assets/images/navbar/round-performance-24px.png"),
          activeImge: require("@/assets/images/navbar/ic_performance.webp"),
          notification: 0,
        },
        // 5 : rewards
        {
          label: "Rewards",
          i18nKey: "page.rewards",
          path: "rewards",
          tab: "OS",
          imge: require("@/assets/images/navbar/round-rewards-24px.png"),
          activeImge: require("@/assets/images/navbar/ic_rewards.webp"),
          notification: 10,
        },
        // 6 : questions
        {
          label: "Questions",
          i18nKey: "page.questions",
          path: "questions",
          tab: "standard",
          imge: require("@/assets/images/navbar/round-questions-24px.png"),
          activeImge: require("@/assets/images/navbar/ic_questions.webp"),
          notification: 0,
        },
        // 7 : skills
        {
          label: "Skills",
          i18nKey: "page.skills",
          path: "skills",
          tab: "overview",
          imge: require("@/assets/images/navbar/nav_skills_24dp.png"),
          activeImge: require("@/assets/images/navbar/ic_skills.webp"),
          notification: 0,
        },
        // 7a : programs
        {
          label: "Programs",
          i18nKey: "page.programs",
          path: "programs",
          tab: "templates",
          imge: require("@/assets/images/navbar/ic_programs.png"),
          activeImge: require("@/assets/images/navbar/ic_programs_active.png"),
          notification: 0,
        },
        // 8 : sparks
        {
          label: "Sparks",
          i18nKey: "page.sparks",
          path: "sparks",
          tab: "nudges",
          imge: require("@/assets/images/navbar/sparks-outline-24px.png"),
          activeImge: require("@/assets/images/navbar/ic_sparks.webp"),
          notification: 0,
        },
        // 9 : happily-village
        {
          label: "Happily Village",
          i18nKey: "page.happilyVillage",
          path: "happily-village",
          tab: "overview",
          imge: require("@/assets/images/navbar/round-village-24px.png"),
          activeImge: require("@/assets/images/navbar/ic_happily_village.webp"),
          notification: 0,
        },
        // 10 : reports
        {
          label: "Reports",
          i18nKey: "page.reports",
          path: "reports",
          tab: "daily",
          imge: require("@/assets/images/navbar/assignment_outline.png"),
          activeImge: require("@/assets/images/navbar/ic_reports.webp"),
          notification: 0,
        },
        // 11 : billing
        {
          label: "Billing",
          i18nKey: "page.billing",
          path: "billing",
          tab: false,
          imge: require("@/assets/images/navbar/round-billing-24px.png"),
          activeImge: require("@/assets/images/navbar/ic_billing.webp"),
          notification: 0,
        },
        // 12 : integrations
        {
          label: "Integrations",
          i18nKey: "page.integrations",
          path: "integrations",
          tab: "overview",
          imge: require("@/assets/images/navbar/round-integrations-24px.png"),
          activeImge: require("@/assets/images/navbar/ic_integrations.png"),
          notification: 0,
        },
        // 13 : awards
        {
          label: "Awards",
          i18nKey: "page.awards",
          path: "awards",
          tab: "status",
          imge: require("@/assets/images/navbar/round-outline-star-24dp.png"),
          activeImge: require("@/assets/images/navbar/round-outline-star-24dp.png"),
          notification: 0,
        },
        // 14 : Status Page
        {
          label: "Status Page",
          i18nKey: "page.statusPage",
          path: "status-page",
          tab: false,
          imge: require("@/assets/images/navbar/round-status-24px.png"),
          activeImge: require("@/assets/images/navbar/ic_status_page.webp"),
          notification: 0,
        },
        // 15 : settings
        {
          label: "Settings",
          i18nKey: "page.settings",
          path: "settings",
          tab: false,
          imge: require("@/assets/images/navbar/round-settings-24px.png"),
          activeImge: require("@/assets/images/navbar/ic_settings.webp"),
          notification: 0,
        },
        // 16 : Documentation
        {
          label: "Documentation(Dev)",
          i18nKey: "page.documentation_dev",
          path: "document-developer",
          tab: "update",
          imge: require("@/assets/images/navbar/round-document-24px.png"),
          activeImge: require("@/assets/images/navbar/round-document-24px.png"),
          notification: 0,
        },
      ],
      navGroups: [
        { label: "Analyze", i18nKey: "page.nav_groups.analyze", paths: ["insights", "reports"] },
        { label: "Manage", i18nKey: "page.nav_groups.manage", paths: ["members", "questions", "rewards"] },
        { label: "Develop", i18nKey: "page.nav_groups.develop", paths: ["performance", "skills", "programs"] },
        { label: "Engage", i18nKey: "page.nav_groups.engage", paths: ["recognition", "sparks", "awards", "happily-village"] },
        { label: "Admin", i18nKey: "page.nav_groups.admin", paths: ["billing", "integrations", "status-page", "settings", "document-developer"] },
      ],
    };
  },
  mounted() {
    this.$store.dispatch("authen/pagePermission");
    this.$store.dispatch("reward/getRewardsMaster").then(()=>{this.$store.dispatch("reward/getRewards", this.user)});
    this.resetIdleTimer();
    this.checkIdleTime();
    this.startActiveSessionCheck();
    window.addEventListener('mousemove', this.resetIdleTimer);
    window.addEventListener('keydown', this.resetIdleTimer);
    window.addEventListener('click', this.resetIdleTimer);
    window.addEventListener('focus', this.checkActiveSession);
    document.addEventListener('visibilitychange', this.handleVisibilitySessionCheck);
    window.addEventListener('keydown', this.modeToggle );
    setTimeout(() => {
      this.permissionLoading = true;
      this.redirectPath();
    }, 3000);
    this.$nextTick(() => this.startupBlurModal());
  },
  beforeDestroy() {
    window.removeEventListener('mousemove', this.resetIdleTimer);
    window.removeEventListener('keydown', this.resetIdleTimer);
    window.removeEventListener('click', this.resetIdleTimer);
    window.removeEventListener('focus', this.checkActiveSession);
    document.removeEventListener('visibilitychange', this.handleVisibilitySessionCheck);
    window.removeEventListener('keydown', this.modeToggle);
    window.removeEventListener('keydown', this.navKeydown);
    window.removeEventListener('keydown', this.navExKeydown);
    clearInterval(this.activeSessionCheckTimer);
  },
  methods: {
    getUrl(){
      const ciphertext = CryptoJS.AES.encrypt(this.companyData.key+'||'+this.companyData.name, 'company-health-status').toString();
      const url = 'https://insights.happily.ai/company-health-status/'+encodeURIComponent(ciphertext);
      this.urlStausPage = url;
    },
    getImgUrl(pic) {
      var images = require.context("../../assets/images/", false, /\.png$/);
      return images("./" + pic + ".png");
    },
    resetIdleTimer() {
      clearTimeout(this.idleTimer);
      this.idleTimer = setTimeout(() => this.logout('idle_timeout'), this.idleTimeout);
      // Store the last activity timestamp in local storage
      localStorage.setItem('lastActivity', Date.now().toString());
    },
    checkIdleTime() {
      const lastActivity = localStorage.getItem('lastActivity');
      if (lastActivity) {
        const idleTime = Date.now() - parseInt(lastActivity, 10);
        if (idleTime >= this.idleTimeout) {
          this.logout('idle_timeout');
        }
      }
    },
    startActiveSessionCheck() {
      this.checkActiveSession();
      clearInterval(this.activeSessionCheckTimer);
      this.activeSessionCheckTimer = setInterval(this.checkActiveSession, this.activeSessionCheckInterval);
    },
    async checkActiveSession() {
      if (this.activeSessionCheckInFlight) return;
      this.activeSessionCheckInFlight = true;
      try {
        await this.$store.dispatch('authen/validateCurrentUserExists');
      } finally {
        this.activeSessionCheckInFlight = false;
      }
    },
    handleVisibilitySessionCheck() {
      if (!document.hidden) {
        this.checkActiveSession();
      }
    },
    setupWizardWatch(to) {
      
      if (to.name == "setup-wizard") {
        this.setupWizardPage = true;
      } else {
        this.setupWizardPage = false;
      }

      let status = false;
      if (to.name == "members") {
        status = true;
        this.stepTutorial = 1;
      } else if (to.name == "questions") {
        status = true;
        this.stepTutorial = 2;
      } else if (to.name == "rewards") {
        status = true;
        this.stepTutorial = 3;
      } else if (to.name == "insightsWithTab") {
        status = true;
        this.stepTutorial = 4;
      } else if (to.name == "settings") {
        status = true;
        this.stepTutorial = 5;
      }
      if (!this.$route.query.welcome) {
        status = false;
      }
      setTimeout(() => {
        this.visible = status;
      }, 200);
    },
    backToStart() {
      this.showNavbar = false;
      window.scrollTo(0, 0);
    },
    handleCommand(command) {
      if (command == "logout") {
        this.logout('manual');
      } else if (command.startsWith("lang-")) {
        const langCode = command.replace("lang-", "");
        this.setLanguage(langCode);
      }
    },
    logout(reason) {
      this.$store.dispatch("auth/logout", { reason: reason || 'manual' });
    },
    nextStepTutorial() {
      if (this.stepTutorial < 5) {
        this.stepTutorial = this.stepTutorial + 1;
        switch (this.stepTutorial) {
          case 2:
            this.$router.push({
              name: "questions",
              params: { tab: "standard" },
              query: { welcome: "true" },
            });
            break;
          case 3:
            this.$router.push({
              name: "rewards",
              params: { tab: "OS" },
              query: { welcome: "true" },
            });
            break;
          case 4:
            this.$router.push({
              name: "insightsWithTab",
              params: { tab: "dashboard" },
              query: { welcome: "true" },
            });
            break;
          case 5:
            this.$router.push({
              name: "settings",
              query: { welcome: "true" },
            });
            break;
        }
      } else {
        this.visible = false;
      }
    },
    onMenuClick(menu) {
      // Intercept clicks on locked side-nav items. If the current user
      // doesn't have access (e.g. free-tier company clicking a premium
      // route), show the Upgrade modal instead of silently no-op'ing.
      const locked = this.userPermLock(menu.path);
      if (locked) {
        this.upgradeModalFeature = menu.label || menu.path || '';
        this.upgradeModalVisible = true;
        return;
      }
      this.routerLink(menu.path, menu.tab, false);
    },
    routerLink(name, tab, locked) {
      const paramsTab = this.$router.currentRoute.params.tab;
      const currentName = this.$router.currentRoute.name;

      if (!locked) {
        if(name=='status-page'){
          window.open(this.urlStausPage, '_blank');
        }else if (tab && tab != paramsTab) {
          this.$router.push({ name: name, params: { tab: tab }});
        } else if (currentName != name) {
          this.$router.push({ name: name });
        }
      }
    },
    linkActive(path) {
      return path === this.activeItemPath ? "active" : "";
    },
    redirectPath() {
      let reFormant = this.$router.currentRoute.path.split("-").join("_");
      let redirect = true;
      let reg = /\x54$/;
      if (
        Object.keys(localStorage).length > 0 &&
        localStorage.developer &&
        localStorage.developer.match(reg)
      ) {
        console.warn("🛠: Ghost mode opened!");
        this.user.user_type = "ghost"; // 👻: ghosttttttttttt
      }
      if (this.pagePermission && reFormant.length > 0) {
        reFormant = reFormant.split("/")[1];
        redirect = this.userPerm(reFormant);
      }
      if (!redirect) {
        this.$message({
          showClose: false,
          message:
            this.user.user_type.toUpperCase() +
            ": Forbidden you don't have permission to access",
          type: "error",
          duration: 4000,
        });
        this.$router.push({ name: "index" });
      }
      const path = localStorage.getItem("pageBeforeLogin");
      localStorage.removeItem("pageBeforeLogin");
      if (path && path !== "/") {
        setTimeout(() => {
          this.$router.replace(path);
        }, 300);
      }
    },
    userPerm(path) {
      if (this.pagePermission) {
        const reFormant = path.split("-").join("_");
        const user_type = this.user.user_type;
        if (
          this.pagePermission[reFormant] &&
          this.pagePermission[reFormant][user_type] &&
          !this.pagePermission[reFormant][user_type].disable
        ) {
          if (reFormant == "integrations" && this.companyData) {
            const perm =
              this.companyData.show_integration &&
              this.companyData.show_integration == "Y";
            return perm && this.pagePermission[reFormant][user_type];
            // return true;
          } else {
            return !this.pagePermission[reFormant][user_type].disable;
          }
          return !this.pagePermission[reFormant][user_type].disable;
        } else if (this.pagePermission[reFormant] == undefined) {
          return true;
        }
      }
      return false;
    },
    userPermLock(path, checked) {
      return this.$utils("permissions", {
        perm: this.pagePermission,
        path: path,
        type: "lock",
        user_type: this.user.user_type,
      });
    },
    isPlanLocked(path) {
      // Show PRO badge only when the lock comes from being on the free
      // plan, not from a role-based restriction.
      if (!this.isFreePlan) return false;
      const normalized = (path || '').split('-').join('_');
      return PLAN_LOCKED_PATHS.indexOf(normalized) !== -1;
    },
    goToBillingUpgrade() {
      const target = { path: '/billing', hash: '#upgrade' };
      const current = this.$router.currentRoute;
      if (current.path === '/billing') {
        if (current.hash !== '#upgrade') {
          this.$router.replace(target).catch(() => {});
        }
        this.$nextTick(() => {
          const el = document.getElementById('upgrade');
          if (el && typeof el.scrollIntoView === 'function') {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
        return;
      }
      this.$router.push(target).catch(() => {});
    },
    modeToggle(e) {
      //try e.code == "KeyD" if key doesn't work
      if ( (e.key == "d" || e.key == "∂") && (e.ctrlKey || e.metaKey) && e.altKey ) {
        this.$store.commit('demomode/changeBlurMode');
      } else if ( e.key == "k" && ((e.ctrlKey || e.metaKey))){
        e.preventDefault(); // Prevent default browser behavior
        this.navMode = true;
        
        // Clear any previous input and auto-select the first item
        this.inputSearch = '';
        
        //sometimes will be called too soon before ref is mounted when page is still loading
        this.$nextTick(() => {
          // Focus on the search input
          if (this.$refs.navsearchRef) {
            this.$refs.navsearchRef.focus();
          }
          
          // Auto-select items in various tables but maintain input focus
          this.$nextTick(() => {
            // Auto-select items but DO NOT focus on them
            if (this.hasRecents && this.commandsRecents.length > 0 && this.$refs.recentsRef) {
              this.$refs.recentsRef.setCurrentRow(this.commandsRecents[0]);
            } else if (this.hasCommon && this.commandsCommon.length > 0 && this.$refs.commonRef) {
              this.$refs.commonRef.setCurrentRow(this.commandsCommon[0]);
            }
            
            // Make sure search input still has focus
            if (this.$refs.navsearchRef) {
              this.$refs.navsearchRef.focus();
            }
          });
        });
      }
    },
    startupBlurModal() {
      if (this.blurMode) {
        this.showSavedBlur = true;
      }
    },

    navListeners() {
      this.$nextTick(() => {
        if (this.navMode) {
          if (!this.navExTraverse.inExpandCell) {
            //if event listener doesn't exist, removeEventListener will have no effect
            window.removeEventListener('keydown', this.navExKeydown);
            //if event listener is already in list of events, it will not be added a second time
            window.addEventListener('keydown', this.navKeydown);
          } else {
            window.removeEventListener('keydown', this.navKeydown);
            window.addEventListener('keydown', this.navExKeydown);
          }
        } else {
          window.removeEventListener('keydown', this.navKeydown);
          window.removeEventListener('keydown', this.navExKeydown);
        }
      });
    },

    recentsIndexes({row, column, rowIndex, columnIndex}) {
      if (columnIndex == 0) return `navcell recents-${rowIndex}`;
      else if (columnIndex == 1) return 'navcell';
    },

    commonIndexes({row, column, rowIndex, columnIndex}) {
      if (columnIndex == 0) return `navcell common-${rowIndex}`;
      else if (columnIndex == 1) return 'navcell';
    },

    resultsIndexes({row, column, rowIndex, columnIndex}) {
      if (columnIndex == 0) return `navcell search-result-${rowIndex}`;
      else if (columnIndex == 1) return 'navcell';
    },


    clearNav() {
      this.clearExpand();
      this.clearNavTraverse();
      this.clearNavExTraverse();
      this.navExpandedRow.current = [];
      this.inputSearch = '';
    },

    clearExpand() {
      this.navExpandedRow.expandSearch = '';
      this.navExpandedRow.memberObject = '';
      this.navExpandedRow.expandTime = '';
      this.navExpandedRow.memberReady = false;
      this.navExpandedRow.timeReady = false;
      this.navExpandedRow.navCall = false;
    },

    clearNavTraverse() {
      var clear = {
        refName: 'navsearchRef',
        tableData: '',
        currentRow: '',
        oldCurrentRow: '',
        index: -1,
        expandable: false
      };
      this.navTraverse = clear;
    },

    clearNavExTraverse() {
      var exclear = {
        inExpandCell: false,
        currentCell: '',
        currentElementName: '',
        currentDropped: false,
        elements: [
          ["navExpandSearch", "navExpandTime"],
          "navExpandGo"
        ]
      };
      this.navExTraverse = exclear;
    },

    handleRecentsRow(currentRow, oldCurrentRow) {
      if (currentRow != null) {
        this.setNavTraverseData(currentRow, oldCurrentRow, 'recentsRef');
      }
    },

    handleCommonRow(currentRow, oldCurrentRow) {
      if (currentRow != null) {
        this.setNavTraverseData(currentRow, oldCurrentRow, 'commonRef');
      }
    },

    handleResultsRow(currentRow, oldCurrentRow) {
      if (currentRow != null) {
        this.setNavTraverseData(currentRow, oldCurrentRow, 'searchresultsRef');
      }
    },

    handleSearchBarRow() {
      this.setNavTraverseData('', '', 'navsearchRef');
    },

    setNavTraverseData(currentRow, oldCurrentRow, ref) {
      var trav = this.navTraverse;
      this.clearNavExTraverse();
      if (ref != trav.refName) {
        if (trav.refName == "navsearchRef") {
          var oldRef = this.$refs[`${trav.refName}`];
          oldRef.blur();
        } else if (trav.refName != "") {
          var oldRef = this.$refs[`${trav.refName}`];
          oldRef.setCurrentRow();
        }
        oldCurrentRow = '';
      }

      trav.currentRow = currentRow;
      trav.oldCurrentRow = oldCurrentRow;
      var tableRef = this.$refs[`${ref}`];
      
      if (ref == 'navsearchRef') {
        trav.tableData = '';
        trav.index = -1;
      } else {
        trav.tableData = tableRef.data;
        trav.index = _.indexOf(tableRef.data, currentRow);
        if (currentRow.expandable_ID != "") trav.expandable = true;
        else trav.expandable = false;
      }
      trav.refName = ref;
      var commandElement = this.getCommandElement(ref);
      if (commandElement != '') this.focusOnElement(commandElement);
    },

    getCommandElement(ref) {
      var trav = this.navTraverse;
      var commandElement = '';
      var tableRef = this.$refs[`${ref}`];
      switch(ref) {
        case "navsearchRef":
          tableRef.focus(this.focusOptions);
          this.$refs.navdialogbodyRef.scroll(0,0);
          break;
        case "recentsRef":
          commandElement = document.querySelector(`.recents-${trav.index}`);
          break;
        case "commonRef":
          commandElement = document.querySelector(`.common-${trav.index}`);
          break;
        case "searchresultsRef":
          commandElement = document.querySelector(`.search-result-${trav.index}`);
          break;
        default:
          break;
      }
      return commandElement;
    },

    setMoveCurrent(row, newRef) {
      var trav = this.navTraverse;
      if (newRef) var tableRef = this.$refs[`${newRef}`];
      else var tableRef = this.$refs[`${trav.refName}`];
      tableRef.setCurrentRow(row);
    },

    navKeydown(e) {
      const currentRef = this.navTraverse.refName;
      const inSearchBar = (currentRef == "navsearchRef");
      const inRecents = (currentRef == "recentsRef");
      const aboveExpandCell = ((this.navExpandedRow.current[0] == this.navTraverse.currentRow.command_ID) && !inSearchBar);
      
      // Handle Enter key specially - it should work regardless of where focus is
      if (e.key == "Enter") {
        e.preventDefault();
        // If we're not in the search bar, handle normal enter press
        if (!inSearchBar && this.navTraverse.currentRow) {
          this.pressEnterCurrent();
        } 
        // If we're in the search bar, but we have a selected row in the results, submit that
        else if (this.currentlySearching && this.commandsResults.length > 0) {
          this.handleNavLink(this.commandsResults[0]);
        }
        // If we're in the search bar, but we have recents and no search, submit the first recent
        else if (!this.currentlySearching && this.hasRecents && this.commandsRecents.length > 0) {
          this.handleNavLink(this.commandsRecents[0]);
        }
        // If we're in the search bar, but we have commons and no recents, submit the first common
        else if (!this.currentlySearching && !this.hasRecents && this.hasCommon && this.commandsCommon.length > 0) {
          this.handleNavLink(this.commandsCommon[0]);
        }
        return;
      }
      
      // Handle navigation and other keys only when not in search bar
      if (!inSearchBar) {
        if (e.key == "ArrowUp") {
          e.preventDefault();
          this.moveUpCurrent();
        } else if (e.key == "ArrowDown") {
          e.preventDefault();
          if (aboveExpandCell) this.moveIntoExpandCell();
          else this.moveDownCurrent();
        } else if ((e.key == "Backspace" || e.key == "Delete") && inRecents) {
          this.deleteCurrent();
        }
      } else if (e.key == "ArrowDown" && inSearchBar) {
        // Allow down arrow to move from search bar to first result
        e.preventDefault();
        this.moveDownCurrent();
      }
      
      // Escape key should always work
      if (e.key == "Escape") {
        this.navMode = false;
        this.clearNav();
      }
    },

    moveUpCurrent() {
      var trav = this.navTraverse;
      if (trav.index > 0) {
        this.setMoveCurrent(trav.tableData[trav.index - 1]);
      } else if (trav.index == 0) {
        const currentRef = trav.refName;
        var newRef = "";
        if (currentRef == "commonRef" && this.hasRecents) {
          newRef = "recentsRef";
          var tableRef = this.$refs[`${newRef}`];
          var row = tableRef.data[tableRef.data.length-1];
          this.setMoveCurrent(row, newRef);
        } else {
          newRef = "navsearchRef";
          this.handleSearchBarRow();
        }
      }
    },

    moveDownCurrent() {
      var trav = this.navTraverse;
      var bound = trav.tableData.length-1;
      if (trav.index < bound) {
        this.setMoveCurrent(trav.tableData[trav.index + 1]);
      } else if (trav.index == bound) {
        const currentRef = trav.refName;
        var newRef = "";
        if (currentRef == "navsearchRef") {
          if (this.currentlySearching) {
            newRef = "searchresultsRef"
          } else if (this.hasRecents) {
            newRef = "recentsRef";
          } else if (this.hasCommon) {
            newRef = "commonRef";
          }
        } else if (currentRef == "recentsRef" && this.hasCommon) {
          newRef = "commonRef";
        }
        if (newRef != "") {
          var tableRef = this.$refs[`${newRef}`];
          var row = tableRef.data[0];
          this.setMoveCurrent(row, newRef);
        }
      }
    },

    pressEnterCurrent() {
      var trav = this.navTraverse;
      var tableRef = this.$refs[`${trav.refName}`];
      if (trav.currentRow != '' && !trav.expandable) {
        this.handleNavLink(trav.currentRow);
      } else if (trav.expandable) {
        tableRef.toggleRowExpansion(trav.currentRow);
      }
    },

    deleteCurrent() {
      var trav = this.navTraverse;
      var tableRef = this.$refs[`${trav.refName}`];
      var index = trav.index;
      this.deleteRecent(trav.currentRow);
      if (this.hasRecents) {
        index = _.min([index, tableRef.data.length-1]);
        this.setMoveCurrent(tableRef.data[index]);
      } else {
        this.handleSearchBarRow();
      }
    },

    navExKeydown(e) {
      var extrav = this.navExTraverse;
      if (e.key == "ArrowUp") {
        if (!extrav.currentDropped) e.preventDefault();
        this.moveUpInExpand();
      } else if (e.key == "ArrowDown") {
        if (!extrav.currentDropped) e.preventDefault();
        this.moveDownInExpand();
      } else if (e.key == "ArrowLeft") {
        e.preventDefault();
        this.moveNextInExpand(-1);
      } else if (e.key == "ArrowRight") {
        e.preventDefault();
        this.moveNextInExpand(1);
      } else if (e.key == "Enter") {
        this.pressEnterExpand();
      } else if (e.key == "Escape") {
        this.navMode = false;
        this.clearNav();
      }
    },

    setExpandDropped(visible) {
      var extrav = this.navExTraverse;
      this.navExTraverse.currentDropped = visible;
      if (!visible) {
        var element = this.getExpandElement(extrav.currentCell, extrav.currentElementName);
        if (element != '') this.focusOnElement(element);
      }
    },

    moveIntoExpandCell() {
      var extrav = this.navExTraverse;
      var cellElement = document.querySelector(".el-table__expanded-cell");
      extrav.currentCell = cellElement;
      extrav.inExpandCell = true;
      var expandId = this.navTraverse.currentRow.expandable_ID;

      if (this.expandable[expandId].options == "") {
        _.remove(extrav.elements[0], (el) => el == "navExpandSearch")
      } else if (this.expandable[expandId].timeOptions == "") {
        _.remove(extrav.elements[0], (el) => el == "navExpandTime")
      }
      
      var elementName = extrav.elements[0][0];
      extrav.currentElementName = elementName;
      var firstElement = this.getExpandElement(cellElement, elementName)

      if (firstElement != '') this.focusOnElement(firstElement);
    },

    clickedIntoExpandCell(elementName) {
      var extrav = this.navExTraverse;
      if (!extrav.inExpandCell) {
        var cellElement = document.querySelector(".el-table__expanded-cell");
        extrav.currentCell = cellElement;
        extrav.inExpandCell = true;
        var expandId = this.navTraverse.currentRow.expandable_ID;

        if (this.expandable[expandId].options == "") {
          _.remove(extrav.elements[0], (el) => el == "navExpandSearch")
        } else if (this.expandable[expandId].timeOptions == "") {
          _.remove(extrav.elements[0], (el) => el == "navExpandTime")
        }
        extrav.currentElementName = elementName;
      }
    },

    exitExpandCell() {
      this.clearNavExTraverse();
      var commandElement = this.getCommandElement(this.navTraverse.refName);
      if (commandElement != '') this.focusOnElement(commandElement);
    },

    moveUpInExpand() {
      var extrav = this.navExTraverse;
      if (extrav.currentElementName == "navExpandGo") {
        //move up to first element as expected
        extrav.currentElementName = extrav.elements[0][0];
        var newElement = this.getExpandElement(extrav.currentCell, extrav.currentElementName);
        if (newElement != '') this.focusOnElement(newElement);
      } else if (!extrav.currentDropped) {
        this.exitExpandCell();
      }
    },

    moveDownInExpand() {
      var extrav = this.navExTraverse;
      var goReady = (this.navExpandedRow.memberReady && this.navExpandedRow.timeReady);
      if (extrav.currentElementName != "navExpandGo") {
        if (extrav.currentDropped) {

        } else if (goReady) {
          //move down to navExpandGo as expected
          extrav.currentElementName = extrav.elements[1];
          var newElement = this.getExpandElement(extrav.currentCell, extrav.currentElementName);
          if (newElement != '') this.focusOnElement(newElement);
        } else {
          var element = this.getExpandElement(extrav.currentCell, extrav.currentElementName);
          if (element != '') this.focusOnElement(element);
        }
      }
    },

    moveNextInExpand(direction) {
      var extrav = this.navExTraverse;
      if (extrav.currentElementName != "navExpandGo") {
        var length = extrav.elements[0].length;
        //length is the modulus divisor, enables looping
        //eg, with two elements, length == 2. At index 0, moving to the left -1 results in a new index of 1, calculated by -1 % 2
        //eg, with three elements, length == 3. At index 0, moving to the left -1 results in a new index of 2, calculated by -1 % 3
        var currentIndex = extrav.elements[0].indexOf(extrav.currentElementName);
        var newIndex = (currentIndex + direction) % length;
        extrav.currentElementName = extrav.elements[0][newIndex];
        var newElement = this.getExpandElement(extrav.currentCell, extrav.currentElementName);
        if (newElement != '') this.focusOnElement(newElement);
      }
    },

    pressEnterExpand() {
      var extrav = this.navExTraverse;
      var goReady = (this.navExpandedRow.memberReady && this.navExpandedRow.timeReady);
      if (extrav.currentElementName == "navExpandTime") {
        var ref = this.$refs.expandTimeRef;
        ref.open("0");
        this.setExpandDropped(true);
      } else if (extrav.currentElementName == "navExpandGo" && goReady) {
        this.handleNavLink(this.navTraverse.currentRow, this.navExpandedRow);
      }
    },

    getExpandElement(cellElement, elementName) {
      var element = '';
      switch(elementName) {
        case "navExpandSearch":
          element = cellElement.querySelector(`.${elementName} > div > input`);
          break;
        case "navExpandTime":
          element = cellElement.querySelector(`.${elementName} > ul > li`);
          break;
        case "navExpandGo":
          element = cellElement.querySelector(`.${elementName}`);
          break;
        default:
          break;
      }
      return element;
    },

    focusOnElement(element) {
      element.setAttribute("tabindex","0");
      element.focus(this.focusOptions);
      element.scrollIntoView(this.scrollOptions);
    },

    handleNavLink(item, expandProps) {
      this.$store.dispatch('navCommands/addRecent', item);
      this.navMode = false;
      var delay = 0;
      if (expandProps) {
        expandProps = _.clone(expandProps);
        const options = this.optionsAllFilter(item.expandable_ID);
        expandProps.memberObject = _.find(options, ['value', expandProps.expandSearch[0]]);
        expandProps.navCall = true;
        this.$store.commit('navCommands/setExpandProps', expandProps);
      }
      if (!this.linkActive(item.path)) {
        delay = 1000;
        this.routerLink(item.path);
      }
      setTimeout(() => this.$root.$emit("changeTab", item), delay);
      if (item.call != "") {
        setTimeout(() => this.$root.$emit(`${item.call}`), delay * 2);
      } //else if (item.call != "" && expandProps) {
        //setTimeout(() => this.$root.$emit(`${item.call}`, expandProps), delay * 2);
      //}
      setTimeout(() => {
        this.clearExpand();
        this.navExpandedRow.current = [];
        this.$store.commit('navCommands/clearExpandProps');
      }, 5000);
    },

    handleExpand( row, expandedRows ) {
      this.clearExpand();
      if (this.navExpandedRow.current[0] == row.command_ID) {
        this.navExpandedRow.current = [];
      } else {
        this.navExpandedRow.current = [row.command_ID];
        const id = row.expandable_ID;
        if (this.expandable[id].options == "") {
          this.navExpandedRow.memberReady = true;
        } else if (this.expandable[id].timeOptions == false) {
          this.navExpandedRow.timeReady = true;
        }
      }
    },

    expandGet: ({
      row,
      rowIndex,
    }) => {
      if (row.expandable_ID == "") {
        return "no-expand";
      } else {
        return "expandable";
      }
    },

    changeExSearch() {
      this.navExpandedRow.memberReady = true;
    },
    changeExTime(value) {
      this.navExpandedRow.expandTime = value;
      this.navExpandedRow.timeReady = true;
    },

    optionsAllFilter(id) {
      const expandable = this.expandable;
      const exObj = expandable[`${id}`];
      if (exObj.options == "optionsUsers") {
        return this.$store.getters["navCommands/getOptionsUsers"];
      } else if (exObj.options == "optionsTeams") {
        return this.$store.getters["navCommands/getOptionsTeams"];
      } else if (exObj.options == "optionsCohorts") {
        return this.$store.getters["navCommands/getOptionsCohorts"];
      } else {
        return this.$store.getters["navCommands/getOptionsAll"];
      }
    },

    timeOptionsFilter(id) {
      const timeId = this.expandable[`${id}`]['timeOptions'];
      const filteredOptions = this.timeOptions[`${timeId}`]
      return filteredOptions;
    },

    addHighlight() {
      let rowIndex = 0;
      for (const position of this.searchHighlights) {
        let target = "";
        if (position.targetId == 'title') target = "commandResultsTitle";
        else if (position.targetId == 'desc') target = "commandResultsDesc";
        const commandElement = document.querySelector(`.search-result-${rowIndex} #${target}`);

        if (commandElement) {
          for (const highlightBound of position.offsetIndexes) {
            const startOffset = highlightBound[0];
            const endOffset = highlightBound[1];

            const maxOffset = commandElement.textContent.length;
            const adjustedStartOffset = Math.min(startOffset, maxOffset);
            const adjustedEndOffset = Math.min(endOffset, maxOffset);

            const range = document.createRange();
            range.setStart(commandElement.firstChild, adjustedStartOffset);
            range.setEnd(commandElement.firstChild, adjustedEndOffset);

            const markElement = document.createElement("mark");
            markElement.className = "highlighted-text";
            range.surroundContents(markElement);
          }
        }
        rowIndex++;
      }
    },

    removeHighlight() {
      if (this.currentlySearching) {
        let rowIndex = 0;
        for (const command of this.commandsResults) {
          const titleElement = document.querySelector(`.search-result-${rowIndex} #commandResultsTitle`);
          const descElement = document.querySelector(`.search-result-${rowIndex} #commandResultsDesc`);

          const title = document.createTextNode(command.commandTitle);
          const desc = document.createTextNode(command.description);

          if (titleElement) titleElement.replaceChildren(title);
          if (descElement) descElement.replaceChildren(desc);
          rowIndex++;
        }
      }
    },

    deleteRecent(command) {
      this.$store.dispatch('navCommands/removeRecent', command);
    },

    getCurrentLanguageName() {
      const languageNames = {
        'en': 'English',
        'th': 'ไทย',
        'ms': 'Bahasa Malaysia',
        'zh-HK': '繁體中文'
      };
      return languageNames[this.selectedLanguage] || 'English';
    },

    setLanguage(langCode) {
      this.selectedLanguage = langCode;
      localStorage.setItem('selectedLanguage', langCode);

      // Set data-language attribute on body for CSS styling
      document.body.setAttribute('data-language', langCode);

      setLocale(langCode);

      // Show confirmation message
      const messages = {
        'en': 'Language set to English',
        'th': 'ภาษาถูกตั้งค่าเป็นไทย',
        'ms': 'Bahasa ditetapkan kepada Bahasa Malaysia',
        'zh-HK': '語言已設定為繁體中文'
      };
      
      this.$message({
        showClose: true,
        message: messages[langCode] || messages['en'],
        type: 'success',
        duration: 3000,
      });
      
      // Emit event for other components to listen to language changes
      this.$root.$emit('languageChanged', langCode);
    },

    loadLanguagePreference() {
      const savedLanguage = localStorage.getItem('selectedLanguage');
      if (savedLanguage && ['en', 'th', 'ms', 'zh-HK'].includes(savedLanguage)) {
        this.selectedLanguage = savedLanguage;
        // Set initial data-language attribute on body
        document.body.setAttribute('data-language', savedLanguage);
        setLocale(savedLanguage);
      } else {
        // Set default language attribute
        document.body.setAttribute('data-language', 'en');
      }
    },
    
  },
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: none;
}

@keyframes rotate {
  0% {
    transform: rotate(0);
  }
  90% {
    transform: rotate(0);
  }
  92% {
    transform: rotate(-15deg);
  }
  95% {
    transform: rotate(25deg);
  }
  98% {
    transform: rotate(-15deg);
  }
  100% {
    transform: rotate(0);
  }
}

.animation-logo {
  animation: rotate;
  animation-iteration-count: infinite;
  animation-duration: 32s;
}

* {
  transition: 0.2s;
}
.md-app {
  min-height: calc(100vh - 32px);
}
.md-drawer {
  width: 256px;
  //  min-width: 256px;
  max-width: calc(100vw - 125px);
  background-color: #6c30cc;
}
.md-list {
  background-color: #6c30cc;
}
.md-toolbar {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0px;
}
.md-button.md-theme-default,
.md-button.md-theme-default:hover {
  text-transform: capitalize !important; /*For Lower case use lowercase*/
}
.md-list.md-theme-default .md-list-item-container {
  border-radius: 23px;
}
.md-list-item:hover {
  background: #5423a2;
  .logout-text {
    color: #fff;
  }
}
.card-tutorial.members {
  top: 210px;
}
.card-tutorial.questions {
  top: 262px;
}
.card-tutorial.rewards {
  top: 312px;
}
.card-tutorial.insights {
  top: 158px;
}
.card-tutorial.settings {
  top: 526px;
}
.card-tutorial {
  position: absolute;
  left: 180px;
  width: calc(540px - 52px);
  height: calc(480px - 52px);
  background-color: #fff;
  padding: 52px;
  word-break: break-word;
  box-shadow: 0 0 44px #0000003b;
}
.title-tutorial {
  font-size: 28px;
  font-weight: 900;
}
.content-tutorial {
  font-size: 16px;
}
.skip-tutorial {
  font-size: 16px;
  color: #747474;
  font-weight: 700;
}
.next-tutorial {
  font-size: 16px;
  color: #32c2d5;
  font-weight: 700;
  margin-left: auto;
}
.arrow-tutorial {
  position: absolute;
  border: 20px solid;
  left: -92px;
  top: 60px;
  border-color: transparent #fff transparent transparent;
}
.web-page-container {
  .mock-navbar {
    width: 100vw;
    height: 0px;
    @media only screen and (max-width: 1024px) {
      height: 56px;
    }
  }
  .navbar {
    position: fixed;
    height: 56px;
    top: -56px;
    z-index: 999;
    transition: 0;
    @media only screen and (max-width: 1024px) {
      top: 0px;
      box-shadow: 0 0 12px #00000090;
    }
    width: 100vw;
    background-color: #5423a2;

    .hamburger-bar {
      cursor: pointer;
      padding: 8px;
      width: 40px;
      height: 40px;
      margin: 8px 16px 8px auto;
      border-radius: 8px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: rgba(255, 255, 255, 0.1);
      
      &:hover {
        background: rgba(255, 255, 255, 0.2);
        transform: scale(1.05);
        
        .line-menu {
          opacity: 0.8;
          background-color: #ffffff;
        }
      }
      
      &:active {
        transform: scale(0.95);
      }
      
      .line-menu {
        width: 20px;
        height: 3px;
        border-radius: 2px;
        background-color: rgba(255, 255, 255, 0.7);
        margin: 2px 0;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        transform-origin: center;
        
        &:first-child {
          margin-top: 0;
        }
        
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  .menu-container {
    z-index: 50;
    width: 0px;
    padding-right: 254px;
    position: relative;
    transition: margin-left 0.2s ease;
    @media only screen and (max-width: 1024px) {
      padding-right: 0px;
    }
    
    .side-menu {
      transition: 0.2;
      width: 254px;
      position: absolute;
      right: 0;
      transition: height 0;
      background:
        linear-gradient(180deg, #6C30CC 0%, #5E28BC 60%, #581FB3 100%);
      height: 100%;
      min-height: calc(100vh - 32px);
      box-shadow: inset 1px 0 0 rgba(255, 255, 255, 0.04);
      .header-menu {
        position: relative;
        padding: 22px 12px 24px;
        background:
          radial-gradient(180px 120px at 85% -10%, rgba(255, 194, 0, 0.10), transparent 70%),
          linear-gradient(180deg, #5423A2 0%, #4A1E8F 100%);

        &::after {
          content: '';
          position: absolute;
          left: 12px;
          right: 12px;
          bottom: 0;
          height: 1px;
          background: linear-gradient(
            90deg,
            transparent 0%,
            rgba(255, 255, 255, 0.08) 20%,
            rgba(255, 194, 0, 0.55) 50%,
            rgba(255, 255, 255, 0.08) 80%,
            transparent 100%
          );
          pointer-events: none;
        }

        .ws-chip {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 6px 10px 6px 6px;
          border-radius: 10px;
          width: fit-content;
          max-width: 100%;
          transition: background 160ms ease, transform 160ms ease;

          &:hover {
            background: rgba(255, 255, 255, 0.06);
          }
          &:active {
            transform: scale(0.995);
          }
          &:focus-visible {
            outline: 2px solid rgba(255, 255, 255, 0.5);
            outline-offset: 2px;
          }
        }
        .ws-chip-logo {
          width: 32px;
          height: 32px;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.25));

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            display: block;
          }
        }
        .ws-chip-meta {
          display: flex;
          flex-direction: column;
          min-width: 0;
          flex: 0 1 auto;
          line-height: 1.15;
        }
        .ws-chip-label {
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: rgba(255, 255, 255, 0.52);
          margin-bottom: 1px;
          user-select: none;
        }
        .ws-chip-name {
          font-size: 14px;
          font-weight: 800;
          color: #fff;
          letter-spacing: -0.1px;
          max-width: 190px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          user-select: none;
        }

        .me-pill {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-top: 10px;
          padding: 6px 10px 6px 6px;
          border-radius: 10px;
          width: 100%;
          box-sizing: border-box;
          background: rgba(255, 255, 255, 0.06);
          border: 1px solid rgba(255, 255, 255, 0.08);
          cursor: pointer;
          transition:
            background 160ms ease,
            border-color 160ms ease,
            transform 160ms ease,
            box-shadow 160ms ease;

          &:hover {
            background: rgba(255, 255, 255, 0.11);
            border-color: rgba(255, 255, 255, 0.18);
            box-shadow: 0 4px 14px rgba(0, 0, 0, 0.22);
            transform: translateY(-1px);

            .me-pill-caret {
              color: #fff;
              transform: translateY(1px);
            }
          }
          &:focus-visible {
            outline: 2px solid rgba(255, 255, 255, 0.5);
            outline-offset: 2px;
          }
        }
        .me-pill-av {
          position: relative;
          width: 30px;
          height: 30px;
          flex-shrink: 0;

          img,
          .me-pill-av-initials {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            object-fit: cover;
            box-shadow:
              inset 0 0 0 1px rgba(255, 255, 255, 0.25),
              0 1px 2px rgba(0, 0, 0, 0.2);
          }
          .me-pill-av-initials {
            background: linear-gradient(135deg, #ffd86b 0%, #ff8a4c 100%);
            color: #5423a2;
            font-size: 12px;
            font-weight: 800;
          }
        }
        .me-pill-presence {
          position: absolute;
          right: -1px;
          bottom: -1px;
          width: 9px;
          height: 9px;
          border-radius: 50%;
          background: #3AC47D;
          box-shadow: 0 0 0 2px #4A1E8F;
        }
        .me-pill-text {
          display: flex;
          flex-direction: column;
          min-width: 0;
          flex: 0 1 auto;
          line-height: 1.15;
        }
        .me-pill-name {
          font-size: 13px;
          font-weight: 700;
          color: #fff;
          max-width: 150px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          user-select: none;
        }
        .me-pill-role {
          font-size: 11px;
          font-weight: 600;
          color: rgba(255, 255, 255, 0.55);
          letter-spacing: 0.2px;
          max-width: 150px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          user-select: none;
        }
        .me-pill-caret {
          color: rgba(255, 255, 255, 0.6);
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          margin-left: auto;
          padding-left: 8px;
          transition: transform 160ms ease, color 160ms ease;
        }

        /* Force Element UI's default inline-block so .me-pill can stretch */
        .el-dropdown {
          display: block;
          width: 100%;
        }
      }

      .body-menu {
        padding: 14px 10px;
        background: transparent;
        
        /* Search shortcut styling */
        .search-shortcut-container {
          display: flex;
          align-items: center;
          background: linear-gradient(135deg, rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.08));
          border-radius: 8px;
          padding: 8px 12px;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          border: 1px solid rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          position: relative;
          overflow: hidden;
          
          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
            transition: left 0.5s ease;
          }
          
          &:hover {
            background: linear-gradient(135deg, rgba(255, 255, 255, 0.18), rgba(255, 255, 255, 0.12));
            border-color: rgba(255, 255, 255, 0.2);
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            
            &::before {
              left: 100%;
            }
            
            .search-shortcut-icon {
              transform: scale(1.1);
            }
          }
          
          &:active {
            transform: translateY(0);
          }
        }
        
        .search-shortcut-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 12px;
          opacity: 0.9;
          transition: transform 0.2s ease;
        }
        
        .search-shortcut-text {
          flex: 1;
          color: #ffffff;
          font-size: 14px;
          font-weight: 500;
          letter-spacing: 0.3px;
        }
        
        .search-shortcut-keys {
          display: flex;
          align-items: center;
          gap: 3px;
        }
        
        .search-key {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 20px;
          height: 20px;
          padding: 2px 5px;
          font-weight: 600;
          font-size: 11px;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Kanit', sans-serif;
          color: rgba(255, 255, 255, 0.95);
          background: rgba(255, 255, 255, 0.2);
          border-radius: 4px;
          border: 1px solid rgba(255, 255, 255, 0.25);
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.3);
          text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);
        }
        
        .nav-group {
          margin-top: 18px;

          & + .nav-group {
            margin-top: 14px;
            padding-top: 14px;
            position: relative;

            &::before {
              content: '';
              position: absolute;
              left: 16px;
              right: 16px;
              top: 0;
              height: 1px;
              background: linear-gradient(
                90deg,
                transparent 0%,
                rgba(255, 255, 255, 0.12) 50%,
                transparent 100%
              );
              pointer-events: none;
            }
          }
          &:hover .nav-group-label,
          &.is-active .nav-group-label {
            color: rgba(255, 194, 0, 0.92);
          }
        }

        .nav-group-label {
          color: rgba(255, 255, 255, 0.48);
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          padding: 0 14px;
          margin-bottom: 6px;
          user-select: none;
          transition: color 160ms ease;
        }

        .router {
          transition:
            background-color 160ms ease,
            opacity 160ms ease,
            transform 160ms ease,
            border-color 160ms ease,
            box-shadow 160ms ease;
          height: 38px;
          opacity: 0.78;
          width: calc(100% - 8px);
          margin: 0 4px 2px;
          padding: 4px 12px;
          cursor: pointer;
          border-radius: 9px;
          position: relative;
          border: 1px solid transparent;
          box-sizing: border-box;

          &:focus-visible {
            outline: 2px solid rgba(255, 255, 255, 0.7);
            outline-offset: 2px;
          }

          &:hover {
            opacity: 1;
            background: rgba(255, 255, 255, 0.06);
            border-color: rgba(255, 255, 255, 0.08);
            transform: translateX(2px);

            .nav-item-icon img {
              transform: scale(1.04);
            }
          }

          &:active {
            transform: translateX(1px) scale(0.995);
          }

          .nav-item-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 22px;
            height: 22px;
            transition: transform 160ms ease;

            img {
              width: 20px;
              height: 20px;
              transition: transform 160ms ease;
            }
          }

          .label {
            margin-left: 12px;
            color: #fff;
            font-size: 14px;
            letter-spacing: 0.1px;
            font-family: "Roboto", 'Kanit', sans-serif;
            font-weight: 500;
            user-select: none;
          }

          .noti-tag {
            color: #fff;
            background: linear-gradient(135deg, #1ac362, #16a085);
            min-width: 18px;
            height: 18px;
            padding: 1px 6px;
            border-radius: 9px;
            font-size: 10px;
            font-weight: 700;
            opacity: 1;
            box-shadow: 0 2px 6px rgba(26, 195, 98, 0.35);
            border: 1px solid rgba(255, 255, 255, 0.18);
            transition: all 160ms ease;
          }

          .noti-tag-pulse {
            animation: pulse-notification 2s infinite;
            will-change: transform;
          }

          .lock-icon {
            opacity: 0.55;
            transition: opacity 160ms ease;

            &:hover {
              opacity: 1;
            }
          }

          .plan-badge {
            color: #2A1A05;
            background: linear-gradient(135deg, #FFD66B, #FFC200);
            min-width: 30px;
            height: 18px;
            padding: 0 7px;
            border-radius: 9px;
            font-size: 9px;
            font-weight: 800;
            letter-spacing: 0.10em;
            line-height: 18px;
            text-align: center;
            font-family: 'Lato', 'Kanit', sans-serif;
            box-shadow: 0 2px 6px rgba(255, 194, 0, 0.30);
            border: 1px solid rgba(255, 255, 255, 0.20);
          }
        }

        .router.active {
          opacity: 1;
          background: rgba(255, 255, 255, 0.10);
          border-color: rgba(255, 255, 255, 0.12);
          box-shadow:
            inset 0 1px 0 rgba(255, 255, 255, 0.06),
            0 2px 10px rgba(0, 0, 0, 0.18);

          .nav-item-icon img {
            transform: scale(1.03);
          }
          .label {
            font-weight: 700;
          }
        }

        @keyframes pulse-notification {
          0%, 100% {
            transform: scale(1);
            box-shadow: 0 2px 6px rgba(26, 195, 98, 0.35);
          }
          50% {
            transform: scale(1.04);
            box-shadow: 0 4px 10px rgba(26, 195, 98, 0.55);
          }
        }
      }

      .plan-footer-card {
        margin: 18px 12px 16px;
        padding: 14px 14px 12px;
        border-radius: 12px;
        background:
          linear-gradient(160deg, rgba(255, 194, 0, 0.14) 0%, rgba(255, 255, 255, 0.04) 80%);
        border: 1px solid rgba(255, 194, 0, 0.32);
        box-shadow:
          inset 0 1px 0 rgba(255, 255, 255, 0.05),
          0 6px 18px -10px rgba(0, 0, 0, 0.45);
        cursor: pointer;
        transition: transform 160ms ease, border-color 160ms ease, background 160ms ease;
        font-family: 'Lato', 'Kanit', sans-serif;
        color: #FFFFFF;
        user-select: none;

        &:hover {
          border-color: rgba(255, 194, 0, 0.55);
          transform: translateY(-1px);
          background:
            linear-gradient(160deg, rgba(255, 194, 0, 0.20) 0%, rgba(255, 255, 255, 0.06) 80%);
        }

        &:focus-visible {
          outline: 2px solid #FFC200;
          outline-offset: 2px;
        }

        .plan-footer-eyebrow {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          font-size: 10px;
          font-weight: 800;
          letter-spacing: 0.16em;
          text-transform: uppercase;
          color: #FFD66B;
        }

        .plan-footer-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #FFC200;
          box-shadow: 0 0 6px rgba(255, 194, 0, 0.7);
        }

        .plan-footer-headline {
          margin-top: 6px;
          font-size: 13px;
          font-weight: 600;
          line-height: 1.35;
          color: rgba(255, 255, 255, 0.95);
        }

        .plan-footer-cta {
          margin-top: 10px;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          font-size: 12px;
          font-weight: 700;
          color: #FFFFFF;
          background: rgba(255, 255, 255, 0.10);
          border: 1px solid rgba(255, 255, 255, 0.16);
          padding: 6px 10px;
          border-radius: 8px;
          transition: background 160ms ease;
        }

        &:hover .plan-footer-cta {
          background: rgba(255, 255, 255, 0.16);
        }
      }

      .diasable-all {
        user-select: none;
        pointer-events: none;
        opacity: 0.4;
      }
    }
  }
  .menu-container.show-menu {
    padding-right: 0px;
    @media only screen and (min-width: 1023px) {
      padding-right: 254px;
    }
    .side-menu {
      right: -254px;
      @media only screen and (min-width: 1023px) {
        right: 0;
      }
    }
  }
  .components-container {
    width: calc(100vw - 255px);
  }
}

/* Account rail layout adjustments */
.web-page-container.with-account-rail {
  margin-left: 48px;
  width: calc(100vw - 48px);
  
  .components-container {
    width: calc(100vw - 255px - 48px);
  }
}
.el-dropdown-menu {
  border-radius: 12px !important;
  box-shadow:
    0 12px 32px rgba(30, 10, 60, 0.16),
    0 2px 8px rgba(30, 10, 60, 0.08) !important;
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
  padding: 6px !important;
  min-width: 220px;
}

.el-dropdown-menu .el-dropdown-menu__item {
  font-size: 14px;
  color: #1a1a2e;
  font-weight: 500;
  padding: 8px 12px !important;
  margin: 1px 0;
  border-radius: 8px;
  line-height: 1.3;
  transition: background-color 140ms ease, color 140ms ease;
}

.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: rgba(108, 48, 204, 0.06);
  color: #6C30CC;
}

.el-dropdown-menu .el-dropdown-menu__item:focus {
  background-color: rgba(108, 48, 204, 0.06) !important;
  color: #6C30CC !important;
}

.el-dropdown-menu .el-dropdown-menu__item.is-disabled {
  color: #ADADAD !important;
  opacity: 0.6;
}

/* Override Element UI's default divided-item top border */
.el-dropdown-menu__item--divided {
  position: relative;
  margin-top: 6px !important;
  border-top: none !important;

  &::before {
    content: '';
    position: absolute;
    left: 6px;
    right: 6px;
    top: -4px;
    height: 1px;
    background: rgba(0, 0, 0, 0.06);
    margin: 0 !important;
  }
}

.dropdown-section {
  padding: 2px 0 4px;
  margin-bottom: 2px;
}

.dropdown-section-title {
  padding: 4px 12px;
  font-size: 10px;
  font-weight: 700;
  color: #95989A;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  margin-bottom: 2px;
  user-select: none;
}

.language-option {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0;
  gap: 10px;
}

.language-flag {
  font-size: 16px;
  line-height: 1;
  min-width: 20px;
  text-align: center;
  flex-shrink: 0;
}

.language-name {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: inherit;
}

.language-check {
  color: #6C30CC;
  font-weight: 700;
  margin-left: auto;
  font-size: 14px;
  line-height: 1;
}

.language-arrow {
  color: #ADADAD;
  font-weight: 400;
  margin-left: auto;
  font-size: 16px;
  line-height: 1;
  transition: color 140ms ease, transform 140ms ease;
}

/* Submenu trigger row */
.language-submenu-trigger {
  &:hover {
    .language-arrow {
      color: #6C30CC;
      transform: translateX(2px);
    }
  }

  .language-option {
    .language-flag {
      font-size: 18px;
    }
    .language-name {
      font-weight: 600;
    }
  }
}

/* Submenu popup (the 4-language list) */
.language-submenu-content {
  min-width: 220px;
  border-radius: 12px;
  box-shadow:
    0 12px 32px rgba(30, 10, 60, 0.16),
    0 2px 8px rgba(30, 10, 60, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.05);
  padding: 6px !important;

  .el-dropdown-menu__item {
    padding: 8px 12px !important;
    margin: 1px 0;
    border-radius: 8px;
    transition: background-color 140ms ease, color 140ms ease;

    &:hover {
      background-color: rgba(108, 48, 204, 0.06) !important;
      color: #6C30CC;
    }

    &.is-active {
      background-color: rgba(108, 48, 204, 0.08) !important;
      color: #6C30CC;
      font-weight: 600;

      &:hover {
        background-color: rgba(108, 48, 204, 0.12) !important;
      }
    }
  }
}

.logout-item {
  display: flex !important;
  align-items: center;
  gap: 10px;
  color: #1a1a2e;

  .el-icon-switch-button {
    font-size: 16px;
    color: #95989A;
    transition: color 140ms ease;
  }

  &:hover {
    background-color: rgba(204, 48, 48, 0.08) !important;
    color: #CC3030 !important;

    .el-icon-switch-button {
      color: #CC3030;
    }
  }
}
        .demomode-notif {
  border: 1px solid rgba(127, 71, 217, 0.6);
  border-radius: 8px;
  background: linear-gradient(135deg, rgba(78, 20, 172, 0.9), rgba(108, 48, 204, 0.8));
  color: #ffffff;
  font-size: 12px;
  font-family: "Roboto", 'Kanit', sans-serif;
  font-weight: 500;
  padding: 8px 12px;
  margin: 0px 0px 12px;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(78, 20, 172, 0.3);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(78, 20, 172, 0.4);
  }
}
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.05s ease-out;
}
.slide-fade-enter {
  transform: translateX(-20px);
  opacity: 0;
}
.slide-fade-leave-to {
  opacity: 0;
}

// Add styles for command icons
.icon-flex-container img {
  height: 22px !important;
  width: 22px !important;
}

/* Keyboard shortcuts */
.shortcut-hint {
  position: absolute;
  bottom: 15px;
  left: 0;
  right: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  gap: 16px;
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  background-color: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  padding: 10px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  
  .key {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 16px;
    height: 20px;
    padding: 1px 5px;
    margin: 0 2px;
    font-weight: 500;
    font-size: 11px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, 'Kanit', sans-serif;
    color: rgba(0, 0, 0, 0.8);
    
    /* Key styling */
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0.9), rgba(240, 240, 240, 0.7));
    border-radius: 3px;
    border: 1px solid rgba(180, 180, 180, 0.5);
    border-bottom: 1px solid rgba(150, 150, 150, 0.6);
    box-shadow: 
      0 1px 2px rgba(0, 0, 0, 0.1),
      inset 0 1px 0 rgba(255, 255, 255, 0.7);
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.8);
  }
}
</style>
<style lang="scss">
#NavigationCommandMenu {
  /* Content styling */

  // Override El-Dialog styles to fix centering
  .el-dialog__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0.2);
    // Removed backdrop-filter from wrapper to avoid blurring the entire background
  }
  
  .el-dialog {
    position: relative !important;
    margin: 0 auto !important;
    top: 0 !important;
    left: 0 !important;
    transform: none !important;
    width: 580px;
    max-height: 520px;
    border-radius: 12px;
    background-color: rgba(255, 255, 255, 0.8); /* More translucent background */
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.2);
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  
  .el-dialog__header {
    padding: 0px;
  }
  
  .el-dialog__headerbtn {
    top: 10px;
    right: 15px;
    z-index: 10;
    .el-dialog__close {
      color: rgba(0, 0, 0, 0.5);
      &:hover {
        color: #6C30CC;
      }
    }
  }
  
  .el-dialog__body {
    padding: 0;
    color: #333333;
    font-size: 13px;
    overflow: hidden;
    flex: 1;
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 180px);
  }
  
  /* Search bar styling */
  .navsearch {
    display: flex;
    align-items: center;
    height: 56px; 
    padding: 0 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    background-color: rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(30px);
    -webkit-backdrop-filter: blur(30px);
  }
  
  .search-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
    opacity: 0.7;
  }
  
  .shortcut-indicator {
    margin-left: 8px;
    padding: 3px 6px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.5);
    background-color: rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    font-weight: 500;
  }

  .el-input__inner {
    border-radius: 0;
    background-color: transparent;
    font-size: 16px;
    border-color: transparent;
    color: #333333;
    padding: 0 8px;
    height: 54px;
  }

  /* Command container */
  .command-container {
    flex: 1;
    padding: 0 16px;
    overflow-y: auto;
    position: relative;
    margin-bottom: 24px; /* Space for the shortcuts */
    background-color: transparent;
    backdrop-filter: blur(10px); /* Some browsers don't support backdrop-filter on backdrop-filter elements */
    -webkit-backdrop-filter: blur(10px); /* Seperated backdrop-filter on header, body and footer individually */
  }

  /* Table styling */
  .el-table {
    background-color: transparent !important;
    color: #333333;
    
    // Remove default focus styles
    &:focus {
      outline: none !important;
    }
    
    .el-table__row {
      background-color: transparent !important;
      
      &:focus {
        outline: none !important;
      }
      
      &:focus-visible {
        outline: none !important;
      }
      
      &:hover {
        background-color: transparent !important;
      }
    }
    
    // Remove blue border from focused cells
    td.el-table__cell {
      background-color: transparent !important;
      
      &:focus {
        outline: none !important;
      }
    }

    .el-table .el-table__cell {
      padding: 8px 0px;
    }
    
    // Ensure current row styling is prominent
    .current-row {
      background-color: transparent !important;
      
      .command-row {
        background-color: rgba(240, 236, 249, 0.3) !important; /* More translucent */
        border-left: 3px solid #6C30CC;
        border-top: 1px solid rgba(255, 255, 255, 0.2);
        border-right: 1px solid rgba(255, 255, 255, 0.2);
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
        outline: none !important;
        box-shadow: 0 4px 12px rgba(108, 48, 204, 0.1);
      }
    }
    
    // Remove focus outline from command rows
    .command-row:focus {
      outline: none !important;
    }
  }
  
  .el-table tr {
    background-color: transparent !important;
  }
  
  .el-table__body {
    background-color: transparent !important;
  }
  
  .el-table__body tr.el-table__row td.el-table__cell {
    background-color: transparent !important;
  }
  
  /* Fix table to match width of container */
  .el-table__body, 
  .el-table__header {
    width: 100% !important;
    table-layout: fixed;
  }
  
  /* Table header styling */
  .navtable-header {
    background-color: rgba(249, 249, 249, 0);
    font-weight: 600 !important;
    padding: 10px 16px !important;
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }
  .navtable-header .cell {
    font-size: 12px !important;
    color: rgba(0, 0, 0, 0.5) !important;
  }
  
  /* Table body wrapper - remove fixed height to prevent individual scrolling */
  .el-table__body-wrapper {
    overflow: visible;
  }
  
  /* Command row styling */
  .command-row {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    border-radius: 6px;
    transition: all 0.15s ease;
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0.15); /* Much more translucent */
    border: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  .command-row:hover {
    background-color: rgba(255, 255, 255, 0.25); /* Still translucent on hover */
    transform: translateX(2px);
    border: 1px solid rgba(255, 255, 255, 0.2);
  }
  
  /* Command icon styling */
  .command-icon {
    flex-shrink: 0;
    margin-right: 12px;
  }
  
  .icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 6px;
    background-color: rgba(0, 0, 0, 0.04);
  }
  
  .icon-container img {
    width: 20px;
    height: 20px;
  }
  
  /* Command content styling */
  .command-content {
    flex: 1;
    min-width: 0; /* Allow content to shrink below min-content width */
    margin-right: 8px;
  }
  
  .command-title {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .command-description {
    font-size: 13px;
    color: rgba(0, 0, 0, 0.6);
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  /* Action buttons styling */
  .action-buttons {
    flex-shrink: 0;
    display: flex;
    align-items: center;
  }
  
  .delete-button {
    background: none;
    border: none;
    padding: 4px;
    cursor: pointer;
    opacity: 0.5;
    border-radius: 4px;
    transition: all 0.15s ease;
  }
  
  .delete-button:hover {
    opacity: 1;
    background-color: rgba(0, 0, 0, 0.06);
  }
  
  /* Keyboard shortcuts */
  .shortcut-hint {
    position: absolute;
    bottom: 0px;
    left: 0;
    right: 0;
    text-align: center;
    display: flex;
    justify-content: center;
    gap: 16px;
    color: rgba(0, 0, 0, 0.6);
    background-color: rgba(255, 255, 255, 0.3); /* More translucent */
    backdrop-filter: blur(30px);
    -webkit-backdrop-filter: blur(30px);
    font-size: 12px;
    padding: 14px 0 14px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);

    .shortcut-text {
      margin: 0 2px;
    }
    
    .key {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 1px 5px;
      background: linear-gradient(to bottom, rgba(255, 255, 255, 0.9), rgba(240, 240, 240, 0.7));
      border-radius: 3px;
      border: 1px solid rgba(180, 180, 180, 0.5);
      border-bottom: 1px solid rgba(150, 150, 150, 0.6);
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.7);
      text-shadow: 0 1px 0 rgba(255, 255, 255, 0.8);
      margin: 0 2px;
      font-weight: 500;
      font-size: 9px;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Kanit', sans-serif;
      min-width: 16px;
      height: 20px;
      color: rgba(0, 0, 0, 0.8);
    }

    .key-icon {
      padding: 4px 5px;
      background: rgba(0, 0, 0, 0.04);
      border-radius: 3px;
      border: 1px solid rgba(180, 180, 180, 0.5);
      border-bottom: 1px solid rgba(150, 150, 150, 0.3);
      box-shadow: 0 1px 2px rgba(119, 119, 119, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.5);
      margin: 0 2px;
      min-width: 16px;
      height: 30px;

      > img {
        width: 11px;
        height: 11px;
      }
    }
  }

  .el-table__empty-text {
    display: none;
  }
}
</style>

// Remove focus outline from table elements
.el-table__body:focus,
.el-table__body-wrapper:focus,
.el-table__cell:focus {
  outline: none !important;
}

// Ensure no focus ring on the container
.command-container:focus {
  outline: none !important;
}

.el-table::before {
  display: none; /* Remove table bottom border */
}

.el-table__empty-block {
  background-color: transparent;
}

/* Highlight styling for search */
mark, .highlighted-text {
  background-color: #ffeb3b;
  color: #333333;
  padding: 0 2px;
  border-radius: 2px;
  font-weight: 500;
}
